
export default {
  computed: {
    categories () {
      return this.$store.state.categories
    },
    settori () {
      return this.$store.state.settori
    },
    slug () {
      const _slug = this.$route.params.slug
      return (_slug !== undefined && _slug !== null && _slug !== '') ? _slug : ''
    }
  }
}
